<script setup>
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const router = useRouter();
const { accountId, currentAccount } = useAccount();
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const accountReady = computed(() => Boolean(currentAccount.value?.id));
const isEnabled = computed(() =>
  isFeatureEnabledonAccount.value(accountId.value, FEATURE_FLAGS.ARROWS_AI)
);

watch(
  [accountReady, isEnabled],
  ([ready, enabled]) => {
    if (ready && !enabled) {
      router.replace({ name: 'home', params: { accountId: accountId.value } });
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex w-full h-full min-h-0">
    <section
      v-if="!accountReady || isEnabled"
      class="flex flex-1 h-full overflow-hidden bg-n-surface-1"
    >
      <router-view />
    </section>
  </div>
</template>
